module.exports = __webpack_public_path__ + "img/rwth_tst_en_rgb_white.88f8bd84.png";